export { default } from './doc-upload-landing';
